"use strict";

var environment = false;

module.exports = {

    /**
     * List of environments available
     */
    environments: {
        LOCAL: "LOCAL",
        DEV: "DEV",
        TEST: "TEST",
        PQA: "PQA",
        PROD: "PROD"
    },

    /**
     * Sets the environment for all the code that needs configured based on environments
     * like URL's for service clients.
     * @param {string} env can be any environment in the environment export below
     */
    set: function set(env) {
        environment = env;
    },

    /**
     * Gets the set environment
     * @returns {string} the set environment, false if nothing is set.
     */
    get: function get() {

        if (!environment) throw Error("Must setup an environment for configuration based settings in common-web!");

        return environment;
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/environments.js
// module id = 128
// module chunks = 0